<template>
    <div id="oppreg-qa">
        <!-- <div class="pricing-tier-qualify">
            <h2 class="text-uppercase px-2 font-weight-bold" style="background-color: yellow;">Your workload qualifies for <span class="text-underline" style="text-decoration-line: underline;">{{workloadForm.fields.Workload_type}}</span> discount based on your responses below</h2>
        </div> -->
        <div class="pricing-tier-requirement">
            <div class="my-2 px-2 py-1 black">
                <label class="font-weight-bold white--text">Pricing Tier Requirement </label>
            </div>
            <label class="font-weight-bold">Reply true or false</label>
            <v-layout align-center>
                <v-flex md9>
                <label class="mr-3">
                    The customer has, or will have, their own consumption services /AWS account direct with AWS or with another partner. DXC is not providing any AWS resale services. <span class="required">*</span>
                    <v-img
                        v-if="isDraftOppRecord && draftRecordData && draftRecordData.Discount_Tier_On_AWS"
                        src="/img/ai-generated.png"
                        width="30"
                        class="inline-img"
                        title="AI Generated"
                      />
                </label>
                </v-flex>
                <v-flex md3 class="text-md-center">
                    <v-btn-toggle v-model="workloadForm.fields.Discount_Tier_On_AWS" @change="onDiscountQuestion1Change">
                        <v-btn
                        :class="{ 
                            'v-btn--active': workloadForm.fields.Discount_Tier_On_AWS === 'True',
                            'disable-events': type==='view'
                        }"
                        value="True"
                        class="black--text btn--qa">True</v-btn>
                        <v-btn
                        :class="{ 
                            'v-btn--active': workloadForm.fields.Discount_Tier_On_AWS === 'False',
                            'disable-events': type==='view'
                        }"
                        value="False"
                        class="black--text btn--qa">False</v-btn>
                    </v-btn-toggle>
                </v-flex>
            </v-layout>
            <v-layout align-center v-if="workloadForm.fields.Discount_Tier_On_AWS === 'False'">
                <v-flex md9>
                <label class="mr-3">
                    The customer has existing AWS account(s) with DXC, but there is no additional AWS resale/consumption with DXC in this OPX. <span class="required">*</span>
                    <v-img
                        v-if="isDraftOppRecord && draftRecordData && draftRecordData.Discount_Tier_On_AWS_2"
                        src="/img/ai-generated.png"
                        width="30"
                        class="inline-img"
                        title="AI Generated"
                    />
                </label>
                </v-flex>
                <v-flex md3 class="text-md-center">
                    <v-btn-toggle v-model="workloadForm.fields.Discount_Tier_On_AWS_2" @change="onDiscountQuestion2Change">
                        <v-btn
                        :class="{ 
                            'v-btn--active': workloadForm.fields.Discount_Tier_On_AWS_2 === 'True',
                            'disable-events': type==='view'
                        }"
                        value="True"
                        class="black--text btn--qa">True</v-btn>
                        <v-btn
                        :class="{ 
                            'v-btn--active': workloadForm.fields.Discount_Tier_On_AWS_2 === 'False',
                            'disable-events': type==='view'
                        }"
                        value="False"
                        class="black--text btn--qa">False</v-btn>
                    </v-btn-toggle>
                </v-flex>
            </v-layout>
            <div v-if="workloadForm.fields.Discount_Tier_On_AWS === 'True' || workloadForm.fields.Discount_Tier_On_AWS_2 === 'True'">
                <div class="my-2 px-2 py-1 black">
                    <label class="font-weight-bold white--text">There is NO NEED to respond to the discount qualification question.  Continue to the next section</label>
                </div>
                <div class="text-md-center">
                    <v-btn
                        class="auto"
                        color="success"
                        @click="continueToNextStep">
                        CONTINUE
                    </v-btn>
                </div>
            </div>
            <div class="my-2 px-2 py-1 black" v-if="workloadForm.fields.Discount_Tier_On_AWS === 'False' && workloadForm.fields.Discount_Tier_On_AWS_2 === 'False'" >
                <label class="font-weight-bold white--text">Please continue to Pricing Tier Qualification</label>
            </div>
        </div>

        <div align-center style="position:relative">
            <div v-if="(workloadForm.fields.Discount_Tier_On_AWS === 'True' || !workloadForm.fields.Discount_Tier_On_AWS) || (workloadForm.fields.Discount_Tier_On_AWS_2 === 'True' || !workloadForm.fields.Discount_Tier_On_AWS_2)" class="disabled-section"></div>
            <strong>NOTE: All fields with <span class="required">*</span> are required</strong>
            <div class="pricing-tier-overview-container mb-3">
                <div class="my-2 px-2 py-1 black">
                    <label class="font-weight-bold white--text">Pricing Tiers Overview [<a href="#" @click="downloadGuide" >Download Oppreg Guide for more details</a>] </label>
                </div>
                <p>DXC’s approved discounts for AWS Services are indexed to AWS Public/Published Pricing</p>
                <ul>
                    <li><a href="#" @click="downloadGuide" ><u>Download Oppreg Guide</u></a> for discount details. Note the public sector SPP qualifications in the OppReg guide.</li>
                    <li>Solution Provider Program (SPP) – up to 12% discount (with new account ID) for the first 2 years and 7% thereafter. </li>
                    <li>Private Pricing Agreement (PPA) – 21% discount for qualified workloads.</li>
                    <li>View the OppReg guide download for pricing tier details. </li>
                </ul>
            </div>
            <v-layout
                row
                wrap
            >
                <v-flex md12>
                <div class="my-2 px-2 py-1 black">
                    <label class="font-weight-bold white--text">Pricing Qualification Version 2.0</label>
                </div>
                <div class="my-2">
                    <label class="font-weight-bold red--text">Select the ONE statement that applies to the AWS workload *</label>
                </div>

                <v-layout
                    column
                    >
                    <v-radio-group
                        light
                        :disabled="type==='view'"
                        class="pricing-tier-qualification px-3"
                        v-model="workloadForm.fields.Pricing_Tier_Qualification"
                        @change="determineWorkloadType">
                        <v-radio
                            class="my-2 pricing-tier-radio"
                            value="1"
                            color="orange"
                        >
                            <span slot="label" class="ml-2 black--text">1. The solution is based primarily on DXC IP whereby the customer will not have access to the associated AWS services, infrastructure or operating systems managed by DXC.</span>
                        </v-radio>
                        <div v-if="workloadForm.fields.Pricing_Tier_Qualification === '1'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                            <label class="font-weight-bold black--text title">1. Based on your selection of #1, this workload qualifies for the PPA discount</label>
                            <v-img
                                v-if="isDraftOppRecord && draftRecordData && draftRecordData.Pricing_Tier_Qualification === '1'"
                                src="/img/ai-generated.png"
                                width="30"
                                class="inline-img"
                                title="AI Generated"
                            />
                        </div>
                        <v-radio
                            class="my-2 pricing-tier-radio"
                            value="2"
                            color="orange"
                        >
                            <span slot="label" class="ml-2 black--text">2. The customer requires direct access to the AWS Console, workloads, services, or logs. </span>
                        </v-radio>
                        <div v-if="workloadForm.fields.Pricing_Tier_Qualification === '2'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                            <label class="font-weight-bold black--text title">2. Based on your selection of #2, this workload qualifies for the SPP discount</label>
                            <v-img
                                v-if="isDraftOppRecord && draftRecordData && draftRecordData.Pricing_Tier_Qualification === '2'"
                                src="/img/ai-generated.png"
                                width="30"
                                class="inline-img"
                                title="AI Generated"
                            />
                        </div>
                        <v-radio
                            class="my-2 pricing-tier-radio"
                            value="3"
                            color="orange"
                        >
                            <span slot="label" class="ml-2 black--text">3. Don't know yet.</span>
                        </v-radio>
                        <div v-if="workloadForm.fields.Pricing_Tier_Qualification === '3'" class="my-2 px-2 py-1 yellow" style="width: 100%">
                            <label class="font-weight-bold black--text title">3. Based on your selection of #3, For now, the discount defaults to SPP and PPA pricing is not allowed.  Once your opportunity is in solutioning and you're able to select the appropriate qualification statement, go back to the main menu and select "Opportunity Registration/Update Discount Qualification" section. </label>
                            <v-img
                                v-if="isDraftOppRecord && draftRecordData && draftRecordData.Pricing_Tier_Qualification === '3'"
                                src="/img/ai-generated.png"
                                width="30"
                                class="inline-img"
                                title="AI Generated"
                            />
                        </div>
                    </v-radio-group>
                </v-layout>
                <div class="my-2 px-2 py-1 black">
                    <label class="font-weight-bold white--text">Attestation</label>
                </div>
                <v-layout row style="gap: 1rem">
                    <v-flex md6>
                    <v-menu
                        v-model="attestedDateMenu" 
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        full-width
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="attestedDate"
                            label="Attested Date *"
                            v-on="on"
                            readonly
                        >
                            <template slot="append">
                                <v-img
                                v-if="isDraftOppRecord && draftRecordData && draftRecordData.Attested_By_Date"
                                src="/img/ai-generated.png"
                                width="30"
                                title="AI Generated"
                                />
                            </template>
                        </v-text-field>

                        </template>
                        <v-date-picker
                        :disabled="type==='view'"
                        v-model="attestedDate"
                        attach
                        no-title
                        scrollable
                        @input="attestedDateMenu = false"/>
                    </v-menu>
                    </v-flex>
                    <v-flex md6>
                    <v-text-field
                        :disabled="type==='view'"
                        v-validate="{ required: true }"
                        v-model.lazy="workloadForm.fields.Attested_By_Email"
                        :error-messages="errors.collect('Attested_By_Email')"
                        data-vv-name="Attested_By_Email"
                        data-vv-validate-on="blur"
                        label="Email *"
                    >
                        <template slot="append">
                            <v-img
                            v-if="isDraftOppRecord && draftRecordData && draftRecordData.Attested_By_Email"
                            src="/img/ai-generated.png"
                            width="30"
                            title="AI Generated"
                            />
                        </template>
                    </v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout style="gap: 1rem">
                    <v-flex md6>
                    <v-text-field
                        :disabled="type==='view'"
                        v-validate="{ required: true }"
                        v-model.lazy="workloadForm.fields.Attested_By_Title"
                        :error-messages="errors.collect('Attested_By_Title')"
                        data-vv-name="Attested_By_Title"
                        data-vv-validate-on="blur"
                        label="Job Title *"
                    >
                        <template slot="append">
                            <v-img
                            v-if="isDraftOppRecord && draftRecordData && draftRecordData.Attested_By_Title"
                            src="/img/ai-generated.png"
                            width="30"
                            title="AI Generated"
                            />
                        </template>
                    </v-text-field>
                    </v-flex>
                    <v-flex md6>
                    <v-text-field
                        :disabled="type==='view'"
                        v-validate="{ required: true }"
                        v-model.lazy="workloadForm.fields.Attested_By_Manager"
                        :error-messages="errors.collect('Attested_By_Manager')"
                        data-vv-name="Attested_By_Manager"
                        data-vv-validate-on="blur"
                        label="Manager *"
                    >
                        <template slot="append">
                            <v-img
                            v-if="isDraftOppRecord && draftRecordData && draftRecordData.Attested_By_Manager"
                            src="/img/ai-generated.png"
                            width="30"
                            title="AI Generated"
                            />
                        </template>
                    </v-text-field>
                    </v-flex>
                </v-layout>
                <div>
                    <p>Attestation and the response content is required for contractual compliancy. This attestation is subject to audit. Inaccurate responses could change the pricing tier. If you are unsure of responses throughout this application for registration, please defer to your manager to assist. </p>
                </div>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
    props: {
        // workloadForm: {
        //     required: true,
        //     type: Object
        // },
        // sfdcId: {
        //     type: String,
        //     required: true
        // },
        type: {
            type: String,
            required: true
        },
        // view: {
        //     type: String,
        //     required: true
        // }
    },
    data() {
        return {
            attestedDateMenu: false,
        }
    },
    computed: {
        ...mapState('user/requestOppreg', ['workloadForm','workloadStep', 'oppType', 'draftRecordData', 'isDraftOppRecord']),
        attestedDate: {
            get () {
                return window.moment(this.workloadForm.fields.Attested_By_Date).isValid()
                ? this.workloadForm.fields.Attested_By_Date
                : null
            },
            set (date) {
                this.workloadForm.fields.Attested_By_Date = date
            }
        },
    },
    methods: {
        ...mapMutations({
            setWorkloadType: 'user/requestOppreg/setWorkloadType',
            clearDiscountAnswers: 'user/requestOppreg/clearDiscountAnswers'
        }),
        determineWorkloadType () {
            let workloadType
            switch (this.workloadForm.fields.Pricing_Tier_Qualification) {
                case '1':
                    workloadType = 'PPA'
                    break;
                case '2':
                    workloadType = 'SPP'
                    break;
                case '3':
                    workloadType = 'DONTKNOW'
                    break;
                default:
                    break;
            }
            this.setWorkloadType(workloadType)
        },

        onDiscountQuestion1Change(answer) {
            this.clearDiscountAnswers()
            this.workloadForm.fields.Discount_Tier_On_AWS_2 = null
            this.workloadForm.fields.Discount_Tier_On_AWS = answer
            if (answer === 'True') {
                this.setWorkloadType('NONDXC')
            }
        },

        onDiscountQuestion2Change(answer) {
            this.clearDiscountAnswers()
            this.workloadForm.fields.Discount_Tier_On_AWS_2 = answer
            if (answer === 'True') {
                this.setWorkloadType('NODXCRESALE')
            }
        },

        // onDiscountTierChange (discount) {
        //     console.log('discount answer', discount)
        //     this.clearDiscountAnswers()
        //     this.workloadForm.fields.Discount_Tier_On_AWS = discount
        //     if (discount === 'True') {
        //         this.setWorkloadType('Non DXC')
        //     }
        // },
        downloadGuide () {
            window.open(window.location.origin + '/DXC+AWS+Opportunity+Registration+Guide.pdf', '_blank').focus();
        },
        continueToNextStep() {
            this.$emit('continue')
        }
    },
}
</script>
<style lang="scss" scoped>

.pricing-tier-radio /deep/ label {
    color: rgba(0,0,0,.87) !important;
}

#oppreg-qa {

    .disable-events {
        pointer-events: none
    }
    .disabled-section {
        background: #f5f5f5;
        width: 100%;
        position: absolute;
        right: 0px;
        top: 0px;
        z-index: 99;
        height: 100%;
        opacity: 0.7;
    }
    .pricing-tier-overview-container > p {
      border-bottom: 1px solid #000;
      font-size: 16px !important;
      color: #000;
    }

    .pricing-tier-qualification {
        font-weight: bold;
        .pricing-tier-radio {
            input {
                margin: 30px;
            }
        }
    }

    
    .qa-form {
      .v-btn-toggle{ margin:10px 0}
      .v-btn-toggle .v-btn{
        padding: 15px;
        opacity: 1;
      }
      
      .btn--qa{
        font-weight: bold !important;
      }
    }
}

.inline-img {
  display: inline-block;
  vertical-align: middle;
}
   
</style>